<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div
    class="reward-toast-body"
    v-html="renderMarkdownToHtml(body)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { renderMarkdownToHtml } from '@/composables/contentful'

/**
 * Content for a threshold-cross toast (Added / Removed). Renders the resolved markdown body; the
 * pill background + color come from the `reward-toast` class applied to the vue-toastification
 * container at fire time (see `useRewardToasts` + `main.scss`). Added and removed share one pill.
 */
export default defineComponent({
  name: 'RewardToast',
  setup() {
    return { renderMarkdownToHtml }
  },
  props: {
    body: {
      type: String,
      required: true
    }
  }
})
</script>
